import { BaseAPIRequestFactory, RequiredError } from './baseapi';
import type { Configuration } from '../configuration';
import { RequestContext, HttpMethod, ResponseContext, HttpInfo } from '../http/http';
import { ObjectSerializer } from '../models/ObjectSerializer';
import { ApiException } from './exception';
import { isCodeInRange } from '../util';
import type {SecurityAuthentication} from '../auth/auth';
import type {HttpFile} from '../http/http';


import { GetSqlVmNetworkInfoRequest } from '../models/GetSqlVmNetworkInfoRequest';
import { GetSqlVmNetworkInfoResponse } from '../models/GetSqlVmNetworkInfoResponse';

/**
 * no description
 */
export class GetSqlVmNetworkInfoApiRequestFactory extends BaseAPIRequestFactory {

  /**
   * Get network information for an Azure SQL VM
   * @param projectId The project ID
   * @param getSqlVmNetworkInfoRequest The request body for getting SQL VM network information
   */
  public async getSqlVmNetworkInfo(projectId: string, getSqlVmNetworkInfoRequest: GetSqlVmNetworkInfoRequest, _options?: Configuration): Promise<RequestContext> {
    let _config;
    if (!_options) {
      _config = this.configuration;
    } else {
      _config = Object.assign({}, _options, this.configuration);
    }
    


    // verify required parameter 'projectId' is not null or undefined
    if (projectId === null || projectId === undefined) {
      throw new RequiredError("GetSqlVmNetworkInfoApi", "getSqlVmNetworkInfo", "projectId");
    }


    // verify required parameter 'getSqlVmNetworkInfoRequest' is not null or undefined
    if (getSqlVmNetworkInfoRequest === null || getSqlVmNetworkInfoRequest === undefined) {
      throw new RequiredError("GetSqlVmNetworkInfoApi", "getSqlVmNetworkInfo", "getSqlVmNetworkInfoRequest");
    }


    // Path Params
    const localVarPath = '/projects/{projectId}/cloud-accounts/azure/sql-vm-network-info'
      .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));

    let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
    // Make Request Context
    const requestContext = _config.baseServer!.makeRequestContext(localVarPath, HttpMethod.POST, signal);
    requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8")


    // Body Params
    const contentType = "application/json"
    requestContext.setHeaderParam("Content-Type", contentType);
    const serializedBody = JSON.stringify(ObjectSerializer.serialize(getSqlVmNetworkInfoRequest, "GetSqlVmNetworkInfoRequest", ""));
    requestContext.setBody(serializedBody);

    let authMethod: SecurityAuthentication | undefined;
    // Apply auth methods
    authMethod = _config.authMethods!["ApiKeyAuth"]
    if (authMethod?.applySecurityAuthentication) {
      await authMethod?.applySecurityAuthentication(requestContext);
    }

    return requestContext;
  }

}

export class GetSqlVmNetworkInfoApiResponseProcessor {

  /**
   * Unwraps the actual response sent by the server from the response context and deserializes the response content
   * to the expected objects
   *
   * @params response Response returned by the server for a request to getSqlVmNetworkInfo
   * @throws ApiException if the response code was not in [200, 299]
   */
   public async getSqlVmNetworkInfoWithHttpInfo(response: ResponseContext): Promise<HttpInfo<GetSqlVmNetworkInfoResponse >> {
    if (isCodeInRange("200", response.httpStatusCode)) {
      const body: GetSqlVmNetworkInfoResponse = ObjectSerializer.deserialize(
        await response.body.json(),
        "GetSqlVmNetworkInfoResponse", ""
      ) as GetSqlVmNetworkInfoResponse;
      return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    if (isCodeInRange("400", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Invalid request parameters", undefined, response.headers, response);
    }
    if (isCodeInRange("404", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "VM not found or network profile not available", undefined, response.headers, response);
    }
    if (isCodeInRange("500", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Internal server error", undefined, response.headers, response);
    }
    if (isCodeInRange("1XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Informational", undefined, response.headers, response);
    }
    if (isCodeInRange("3XX", response.httpStatusCode)) {
      throw new ApiException<undefined>(response.httpStatusCode, "Redirect", undefined, response.headers, response);
    }
    if (isCodeInRange("4XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Client Error", body, response.headers, response);
    }
    if (isCodeInRange("5XX", response.httpStatusCode)) {
      const body: Error = ObjectSerializer.deserialize(
        await response.body.json(),
        "Error", ""
      ) as Error;
      throw new ApiException<Error>(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
    }

    // Work around for missing responses in specification, e.g. for petstore.yaml
    if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
      throw new ApiException<string | Blob | undefined>(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
    }
    const body: GetSqlVmNetworkInfoResponse = await response.body.json() as GetSqlVmNetworkInfoResponse;
    return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
  }

}
